import React from "react";
import {
  AppContainer,
  Col,
  UiBox,
  UiFormControl,
  UiFormHelperText,
  UiInput,
  UiLink,
  UiText,
  UiTextarea,
  useMediaQuery,
} from "~/components/elements";
import { Link } from "react-router-dom";
import { PAGES, QUERY_MOBILE } from "~/constants";
import { SendContactMessage } from "~/components/shared/SendContactMessage";
import { useInput } from "~/hooks";

function Banner() {
  const [isDesktop] = useMediaQuery(`(min-width: ${QUERY_MOBILE})`, {
    ssr: false,
  });

  const rules = {
    email: { email: { message: "^Please enter a valid email address" } },
    name: { presence: { message: "^Please tell us your name" } },
    message: { presence: { message: "^Hello, how can we help you?" } },
  };

  const [inputs, setInputs, { validation, resetInput }] = useInput({ name: "", email: "", message: "" }, { rules });
  const onClickSendContactBtn = async () => {
    const validationErrors = validation.getErrors();
    if (validationErrors) {
      return;
    }
    resetInput();
  };

  return (
    <UiBox mb={{ base: "120px", lg: "50px" }} mt={{ base: "100px", lg: "180px" }}>
      <AppContainer h="100%" w={{ base: "90%", lg: "52%" }} mr="auto" ml="auto" pos="relative">
        <Col textAlign="center">
          <UiText fontSize={{ base: "sm", lg: "xl" }} lineHeight={{ base: "22px", lg: "30px" }}>
            We are all ears for the sharing of your ideas!
            <br /> Your message will be answered by us promptly the same or next business day
          </UiText>
        </Col>
        <Col mt="40px">
          <UiFormControl>
            <UiTextarea
              placeholder="Message"
              mb="10px"
              rows={9}
              borderRadius="10px"
              value={inputs.message}
              onChange={e => setInputs({ message: e.target.value })}
            />
            {validation?.errors?.message && (
              <UiFormHelperText mt="0px" mb="10px" color="red" fontSize="16px">
                {validation.errors.message[0]}
              </UiFormHelperText>
            )}
          </UiFormControl>
          <UiFormControl>
            <UiInput
              placeholder="Name"
              mb="10px"
              borderRadius="10px"
              value={inputs.name}
              onChange={e => setInputs({ name: e.target.value })}
            />
            {validation?.errors?.name && (
              <UiFormHelperText mt="0px" mb="10px" color="red" fontSize="16px">
                {validation.errors.name[0]}
              </UiFormHelperText>
            )}
          </UiFormControl>
          <UiFormControl>
            <UiInput
              placeholder="Email"
              mb="10px"
              borderRadius="10px"
              value={inputs.email}
              onChange={e => setInputs({ email: e.target.value })}
            />
            {validation?.errors?.email && (
              <UiFormHelperText mt="0px" mb="10px" color="red" fontSize="16px">
                {validation.errors.email[0]}
              </UiFormHelperText>
            )}
          </UiFormControl>
          <UiText my="10px" fontSize="md" lineHeight="20px">
            Your data collected in this form will be used only to contact you and talk about your project. For more
            information, see our&nbsp;
            <UiLink as={Link} to={PAGES.POLICY} color="secondary.600">
              Privacy Policy.
            </UiLink>
          </UiText>
          <SendContactMessage loading={false} onClickSendContactBtn={onClickSendContactBtn} />
        </Col>
      </AppContainer>
    </UiBox>
  );
}

export default Banner;
